import { useContext, useMemo } from "react";

import { UserContext } from "@/shared/contexts/user.context";
import { useGetTestHook } from "@/shared/hooks/tests/useGetTestHook";
import { IAssessmentInvite } from "@/shared/hooks/initializer/use-initialize-candidate.hook";

import { ICandidateAssessment } from "@/modules/assessments/assessments.types";
import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";

import { findCurrentTestId } from "../utils/candidate-assessment-view.utils";

export function useAssessmentTestHook({
  invite,
  assessment,
  currentPage,
  questionsList,
}: {
  invite?: IAssessmentInvite;
  assessment?: ICandidateAssessment;
  currentPage: number;
  questionsList: ILocalizedTestElement[][];
}) {
  const { user } = useContext(UserContext);
  const testId = useMemo(() => {
    if (!assessment || !invite) {
      return;
    }

    let questionsIndex = currentPage ? currentPage - 1 : currentPage;

    if (!questionsList[questionsIndex]) {
      return;
    }

    return findCurrentTestId(questionsList, invite.testAnswers, questionsIndex, assessment?.assessmentTests);
  }, [currentPage, assessment, questionsList, invite]);

  const { test, isLoading } = useGetTestHook(Number(testId), Boolean(user?.userId));

  return { test, isLoading };
}
